import {
  BUSINESS_MAIN_TO_SUB_TYPE_MAP,
  type BusinessMainTypes,
  type BusinessMainTypesWithSubTypes,
  BUSINESS_MAIN_TYPES,
  type BusinessSubTypes,
} from '@Pages/happyFlowPages/businessTypeSelection/consts.ts';
import { typedObjectKeys } from 'src/utils';

export const doesHaveSubTypes = (
  mainBusinessType: BusinessMainTypes
): mainBusinessType is keyof typeof BUSINESS_MAIN_TO_SUB_TYPE_MAP => {
  return mainBusinessType && mainBusinessType in BUSINESS_MAIN_TO_SUB_TYPE_MAP;
};

export const isMainBusinessType = (
  mainBusinessType: BusinessMainTypes | BusinessSubTypes
): mainBusinessType is BusinessMainTypes => {
  return mainBusinessType in BUSINESS_MAIN_TYPES;
};

export const isMainBusinessAndHasSubTypes = (
  mainBusinessType: BusinessMainTypes | BusinessSubTypes
): mainBusinessType is BusinessMainTypesWithSubTypes => {
  return isMainBusinessType(mainBusinessType) && doesHaveSubTypes(mainBusinessType);
};

export const getMainBusinessTypeFromIncomeSource = (incomeSource: BusinessSubTypes) => {
  return (
    typedObjectKeys(BUSINESS_MAIN_TO_SUB_TYPE_MAP).find((mainBusinessType) =>
      BUSINESS_MAIN_TO_SUB_TYPE_MAP[mainBusinessType].some((subType) => subType === incomeSource)
    ) ?? null
  );
};
